import React, { createContext, useContext, useEffect, useState } from "react";

const ThemeContext = createContext();

export function ThemeProvider({ children }) {
  const [dark, setDark] = useState(() => {
    try { return localStorage.getItem("cs_theme") === "dark"; } catch { return false; }
  });

  useEffect(() => {
    const html = document.documentElement;
    if (dark) {
      html.classList.add("dark");
      localStorage.setItem("cs_theme", "dark");
    } else {
      html.classList.remove("dark");
      localStorage.setItem("cs_theme", "light");
    }
  }, [dark]);

  function toggleTheme() { setDark(d => !d); }

  return (
    <ThemeContext.Provider value={{ dark, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() { return useContext(ThemeContext); }
